import type { DynaVault } from '../../../../api/DynaVaultsAPI';

interface VaultIdentity {
  address: `0x${string}`;
  chainId: number;
}

export const getVaultIdentityKey = (vault: VaultIdentity): string =>
  `${vault.chainId}:${vault.address.toLowerCase()}`;

export const mergeVaultLists = <T extends VaultIdentity>(
  ...lists: Array<readonly T[] | undefined>
): T[] => {
  const vaultMap = new Map<string, T>();

  lists.forEach((list) => {
    list?.forEach((vault) => {
      vaultMap.set(getVaultIdentityKey(vault), vault);
    });
  });

  return Array.from(vaultMap.values());
};

export const enrichVaultsWithDetails = (
  vaults: DynaVault[],
  details: Array<DynaVault | null | undefined>
): DynaVault[] => {
  const detailsByVault = new Map(
    details
      .filter((vault): vault is DynaVault => Boolean(vault))
      .map((vault) => [getVaultIdentityKey(vault), vault])
  );

  return vaults.map((vault) => {
    const detail = detailsByVault.get(getVaultIdentityKey(vault));
    if (!detail) return vault;

    return {
      ...vault,
      ...detail,
      vaultType: vault.vaultType ?? detail.vaultType,
    };
  });
};
